import * as Y from 'yjs';

import { WidgetType } from 'shared/widgets/utils';

import { ManifestInitializedProps } from '@/types/ManifestType';
import { genRandId } from '@/utils/core.utils';
import { htmlToXmlFragment } from '@/utils/tiptap';
import {
  DEFAULT_DIRECTION,
  DEFAULT_GAPS,
  DEFAULT_MARGIN_END,
  DEFAULT_MARGIN_START
} from '@/widgets/EnclosureWithBlockTitle/config';
import { createNewFlexSectionData } from '@/widgets/FlexSection/create';
import { FlexSectionDirection } from '@/widgets/FlexSection/types';

export function createNewEnclosureWithBlockTitleData(content: string): ManifestInitializedProps {
  const id = genRandId();
  const fragment = htmlToXmlFragment(content);

  const [verticalSectionData] = createNewFlexSectionData(FlexSectionDirection.column);
  const { id: verticalSectionId } = verticalSectionData;
  const childrenArray = new Y.Array();
  childrenArray.push([verticalSectionId]);

  return [
    {
      id,
      contentObjectData: new Y.Map([
        ['id', id],
        ['type', WidgetType.EnclosureWithBlockTitle],
        ['children', childrenArray],
        ['textType', 'header'],
        ['fragment', fragment],
        ['placeholder', ''],
        [
          'style',
          new Y.Map([
            ['dropzoneDirection', DEFAULT_DIRECTION],
            ['dropzoneMarginStart', DEFAULT_MARGIN_START],
            ['dropzoneMarginEnd', DEFAULT_MARGIN_END],
            ['dropzoneGap', DEFAULT_GAPS]
          ])
        ]
      ])
    },
    verticalSectionData
  ];
}
